<ion-content>
  <div class="container" [style.background]="selectedType?.color">

    <ion-row>
      <ion-col>
          <div class="th-close" (click)="closePopup()">
            <ion-icon name="close-outline"></ion-icon>
          </div>
      </ion-col>
    </ion-row>

    <ion-row class="diplay_block">
      <ion-col class="diplay_block">
          <img class="banner_img" [src]="selectedType?.banner_img"/>
      </ion-col>
    </ion-row>

    <ion-row>
      <div class="th-card">
        <h5>{{team.team_name}}</h5>
        <p> {{ "( " + selectedType?.name + " )"}}</p>
        <div>

          <ion-row class="team-lead-row">
            <ion-col size="2">            
              <img *ngIf="team?.profile_image" class="user-image-size" src={{team.profile_image}}>
              <img *ngIf="!team?.profile_image" class="user-image-size" src="assets/img/treasure_hunt/dummy_user.svg" />
            </ion-col>
            <ion-col size="10">
              <div class="team-lead-name">
                <ion-label>{{team?.created_by}} </ion-label>
                <ion-label class="role">{{'TREASURE_HUNT.TEAM_SELECTION.TEAM_LEAD' | translate}}</ion-label>
              </div>
  
            </ion-col>
          </ion-row>

          <ion-row class="team-lead-row" *ngFor="let member of teamMembers,let i=index" >
              <ion-col size="2" *ngIf="member.active || viewInactiveMembers">            
                <img *ngIf="member?.profile_image" class="user-image-size" src={{member.profile_image}}>
                <img *ngIf="!member?.profile_image" class="user-image-size" src="assets/img/treasure_hunt/dummy_user.svg" />
              </ion-col>
              <ion-col size="10" *ngIf="member.active || viewInactiveMembers">
                <div class="d-flex">
                  <div class="team-lead-name">
                    <ion-label *ngIf="member?.Fname">{{member?.Fname}} {{member?.Lname}}</ion-label>
                    <ion-label  *ngIf="!member?.Fname">{{member?.first_name}} {{member?.last_name}}</ion-label>
                    <ion-label class="role">{{'TREASURE_HUNT_VIEW_MEMBER' | translate}}</ion-label>
                    <ion-label *ngIf="!member.active" class="waiting"> {{'TREASURE_HUNT.WAITING' | translate}}</ion-label>
                  </div>
                  <div *ngIf="cancelMyRequest && !member.active" >
                    <ion-button size="small" class="th-btn" fill="outline" *ngIf="member?.email == userMail"  (click)="cancelRequest()" shape="round">{{'TREASURE_HUNT_VIEW_TEAM-CANCEL_REQUEST' | translate}}</ion-button>
                  </div>
                </div>
              </ion-col>
          </ion-row>

          <ion-row class="action-btn-row">
            <div>
              <ion-button size="small" class="th-btn" fill="outline"  (click)="closePopup()" shape="round">{{'TREASURE_HUNT_VIEW_TEAM-BACK' | translate}}</ion-button>
              <ion-button size="small" class="th-btn th-save-btn" *ngIf="!activate && !cancelMyRequest" [disabled]="teamMembers.length > 4" (click)="joinSelectedTeam()" shape="round">{{'TREASURE_HUNT_VIEW_TEAM-JOIN' | translate}}</ion-button>
              <ion-button size="small" class="th-btn th-save-btn" *ngIf="activate && !cancelMyRequest" (click)="activateSelectedTeam()" shape="round">{{'TREASURE_HUNT_VIEW_TEAM-ACTIVATE' | translate}}</ion-button>
            </div>
          </ion-row>
        </div>

      </div>
    </ion-row>



  </div>

</ion-content>
